import React from 'react'
import { connect } from 'react-redux'
import { Input, TextArea } from 'semantic-ui-react'
import styled from 'styled-components'
import moment from 'moment'
//@ts-ignore
import LKButton from 'shared/LKButton'
//@ts-ignore
import LKModal, { LKModalContainer, actions as LKModalActions } from 'shared/LKModal'
//@ts-ignore
import { FormLayout } from 'shared/newFormElements'

import { viewDelegateModalName } from '../../../constants'
import { translateDelegates } from '../../../helpers'
import { openFileDetails } from '../../../../FileDetails'
import { ClientDelegateViewModalProps } from 'src/features/ClientDetails/types'

const Wrapper = styled.div`
  border: 1px solid lightgrey;
  border-radius: 5px;
  padding: 15px 0;

  .full--width {
    width: 100%;
  }

  .styled--textarea {
    borderradius: 3px;
    background-color: #fff;
    width: 100%;
  }

  .checkbox--wrapper {
    position: absolute;
    top: 5px;
    left: 34%;
  }
`

@LKModalContainer(viewDelegateModalName)
//@ts-ignore
@connect(undefined, {
  openFileDetails,
})
class ClientDelegateViewModal extends React.Component<ClientDelegateViewModalProps> {
  viewFile = () => {
    const { data } = this.props.params

    if (data.LFLID) {
      const file = data.linkedfiles.find((lf) => lf.ID === data.LFLID)

      this.props.openFileDetails({ ID: file.ID, hash: file.HashSum_FileID_, type: file.Ext })
    }
  }

  render() {
    const {
      modalInstanceName,
      closeModal,
      isLoading,
      params: { data },
    } = this.props

    const startDate = moment(data.StartDate).format('DD.MM.YYYY')
    const endDate = moment(data.EndDate).isValid() ? moment(data.EndDate).format('DD.MM.YYYY') : ''

    return (
      <LKModal
        name={modalInstanceName}
        heading={translateDelegates('frm_client_delegate_add_edit')}
        size="medium"
        footer={
          <LKModal.Footer>
            <LKButton alias="ok" onClick={closeModal} disabled={isLoading}>
              OK
            </LKButton>
          </LKModal.Footer>
        }
      >
        <FormLayout labelFieldProportions="4:10" label={translateDelegates('lbl_firstname')}>
          <Input value={`${data.FullName} - ${data.CardNumber}`} className="full--width" disabled />
        </FormLayout>

        <Wrapper>
          <FormLayout labelFieldProportions="4:12" label="">
            <div className="u-flex checkbox--wrapper">
              <Input name="active" type="checkbox" checked={data.Active === 1} disabled />
              <label htmlFor="active" style={{ marginLeft: '10px' }}>
                {translateDelegates('chk_active')}
              </label>
            </div>
          </FormLayout>

          <FormLayout labelFieldProportions="4:10" label={translateDelegates('lbl_relation')}>
            <Input value={data.RLType} className="full--width" disabled />
          </FormLayout>

          <FormLayout labelFieldProportions="4:3" label={translateDelegates('lbl_startdate')}>
            <Input id="startDate" value={startDate} name="startDate" className="full--width" disabled />
          </FormLayout>

          <FormLayout labelFieldProportions="4:3" label={translateDelegates('lbl_enddate')}>
            <Input id="endDate" value={endDate} name="endDate" className="full--width" disabled />
          </FormLayout>

          <FormLayout labelFieldProportions="4:12" label="">
            <div className="u-flex checkbox--wrapper">
              <Input type="checkbox" checked={data.CashOper === 1} disabled />
              <label htmlFor="canOperate" style={{ marginLeft: '10px' }}>
                {translateDelegates('chk_cashoper')}
              </label>
            </div>
          </FormLayout>

          <FormLayout labelFieldProportions="4:10" label={translateDelegates('lbl_share')}>
            <Input value={data.Share} className="full--width" disabled />
          </FormLayout>

          <FormLayout labelFieldProportions="4:10" label={translateDelegates('lbl_comment')} autoHeight>
            <TextArea value={data.Comment} className="u-fluid u-marginTop-5 styled--textarea" disabled />
          </FormLayout>

          <FormLayout labelFieldProportions="4:10" label={translateDelegates('lbl_file_t')}>
            <div className="u-flex">
              <Input value={data.LFLTitle} className="full--width" disabled />

              <LKButton
                alias="preview"
                className="u-marginLeft-5"
                onClick={this.viewFile}
                disabled={data.LFLID === 0}
              />
            </div>
          </FormLayout>
        </Wrapper>
      </LKModal>
    )
  }
}

export const openDelegateViewModal = (data) => LKModalActions.open({ name: viewDelegateModalName, data })

export default ClientDelegateViewModal
